/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AccountSettingsExpirationInMonths } from '../models/AccountSettingsExpirationInMonths';
import type { BatchPrintProjectDetailInput } from '../models/BatchPrintProjectDetailInput';
import type { BatchProjectUpdateVisibilityInput } from '../models/BatchProjectUpdateVisibilityInput';
import type { CrmBusinessLine } from '../models/CrmBusinessLine';
import type { ExtraProjectDetailDto } from '../models/ExtraProjectDetailDto';
import type { MapProjectResult } from '../models/MapProjectResult';
import type { NoteDto } from '../models/NoteDto';
import type { PrintProjectDetailDto } from '../models/PrintProjectDetailDto';
import type { ProjectDetailDto } from '../models/ProjectDetailDto';
import type { ProjectDto } from '../models/ProjectDto';
import type { ProjectDtoListResult } from '../models/ProjectDtoListResult';
import type { ProjectFilterInput } from '../models/ProjectFilterInput';
import type { ProjectRelatedEntitiesContainerDto } from '../models/ProjectRelatedEntitiesContainerDto';
import type { PromotedProjectFilterInput } from '../models/PromotedProjectFilterInput';
import type { SaleDto } from '../models/SaleDto';
import type { UpdateProjectFolderInput } from '../models/UpdateProjectFolderInput';
import type { ViewConstructorResultDto } from '../models/ViewConstructorResultDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ProjectService {

    /**
     * @param version 
     * @param limit 
     * @param offset 
     * @param requestBody 
     * @returns ProjectDtoListResult OK
     * @throws ApiError
     */
    public static filterProjects(
version: string,
limit?: number,
offset?: number,
requestBody?: ProjectFilterInput,
): CancelablePromise<ProjectDtoListResult> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/user/v{version}/Project/Filter',
            path: {
                'version': version,
            },
            query: {
                'limit': limit,
                'offset': offset,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param version 
     * @param limit 
     * @param offset 
     * @param requestBody 
     * @returns ProjectDtoListResult OK
     * @throws ApiError
     */
    public static filterPromotedProjects(
version: string,
limit?: number,
offset?: number,
requestBody?: PromotedProjectFilterInput,
): CancelablePromise<ProjectDtoListResult> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/user/v{version}/Project/Filter/Promoted',
            path: {
                'version': version,
            },
            query: {
                'limit': limit,
                'offset': offset,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param version 
     * @param requestBody 
     * @returns MapProjectResult OK
     * @throws ApiError
     */
    public static getMapProjects(
version: string,
requestBody?: ProjectFilterInput,
): CancelablePromise<MapProjectResult> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/user/v{version}/Project/Map',
            path: {
                'version': version,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param version 
     * @param requestBody 
     * @returns PrintProjectDetailDto OK
     * @throws ApiError
     */
    public static printProjects(
version: string,
requestBody?: BatchPrintProjectDetailInput,
): CancelablePromise<Array<PrintProjectDetailDto>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/user/v{version}/Project/Print',
            path: {
                'version': version,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param projectHashId 
     * @param version 
     * @param requirementId 
     * @returns ProjectDetailDto OK
     * @throws ApiError
     */
    public static getProjectDetail(
projectHashId: string,
version: string,
requirementId?: number,
): CancelablePromise<ProjectDetailDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/user/v{version}/Project/{projectHashId}',
            path: {
                'projectHashId': projectHashId,
                'version': version,
            },
            query: {
                'requirementId': requirementId,
            },
        });
    }

    /**
     * @param projectHashId 
     * @param version 
     * @returns ExtraProjectDetailDto OK
     * @throws ApiError
     */
    public static getExtraProjectDetails(
projectHashId: string,
version: string,
): CancelablePromise<ExtraProjectDetailDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/user/v{version}/Project/{projectHashId}/Extra',
            path: {
                'projectHashId': projectHashId,
                'version': version,
            },
        });
    }

    /**
     * @param projectHashId 
     * @param version 
     * @returns ProjectDto OK
     * @throws ApiError
     */
    public static listVisitedProjectsFromConstructor(
projectHashId: string,
version: string,
): CancelablePromise<Array<ProjectDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/user/v{version}/Project/{projectHashId}/VisitedConstructorProjects',
            path: {
                'projectHashId': projectHashId,
                'version': version,
            },
        });
    }

    /**
     * @param projectHashId 
     * @param version 
     * @returns ViewConstructorResultDto OK
     * @throws ApiError
     */
    public static viewProjectConstructor(
projectHashId: string,
version: string,
): CancelablePromise<ViewConstructorResultDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/user/v{version}/Project/{projectHashId}/Constructor',
            path: {
                'projectHashId': projectHashId,
                'version': version,
            },
        });
    }

    /**
     * @param projectHashId 
     * @param version 
     * @returns SaleDto OK
     * @throws ApiError
     */
    public static getProjectSales(
projectHashId: string,
version: string,
): CancelablePromise<Array<SaleDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/user/v{version}/Project/{projectHashId}/Sales',
            path: {
                'projectHashId': projectHashId,
                'version': version,
            },
        });
    }

    /**
     * @param projectHashId 
     * @param version 
     * @returns NoteDto OK
     * @throws ApiError
     */
    public static getProjectNotes(
projectHashId: string,
version: string,
): CancelablePromise<Array<NoteDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/user/v{version}/Project/{projectHashId}/Notes',
            path: {
                'projectHashId': projectHashId,
                'version': version,
            },
        });
    }

    /**
     * @param requirementId 
     * @param version 
     * @returns ViewConstructorResultDto OK
     * @throws ApiError
     */
    public static viewProjectConstructorWithRequirement(
requirementId: number,
version: string,
): CancelablePromise<ViewConstructorResultDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/user/v{version}/Project/{requirementId}/Constructor/Requirement',
            path: {
                'requirementId': requirementId,
                'version': version,
            },
        });
    }

    /**
     * @param version 
     * @param requestBody 
     * @returns ProjectDetailDto OK
     * @throws ApiError
     */
    public static batchUpdateProjectVisibility(
version: string,
requestBody?: BatchProjectUpdateVisibilityInput,
): CancelablePromise<ProjectDetailDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/user/v{version}/Project/Batch/Update/Visibility',
            path: {
                'version': version,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param version 
     * @param requestBody 
     * @returns any OK
     * @throws ApiError
     */
    public static batchUpdateProjectFolders(
version: string,
requestBody?: UpdateProjectFolderInput,
): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/user/v{version}/Project/Batch/Update/Folders',
            path: {
                'version': version,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param version 
     * @returns ProjectRelatedEntitiesContainerDto OK
     * @throws ApiError
     */
    public static getProjectRelatedEntities(
version: string,
): CancelablePromise<ProjectRelatedEntitiesContainerDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/user/v{version}/Project/Related/Entities',
            path: {
                'version': version,
            },
        });
    }

    /**
     * @param version 
     * @returns CrmBusinessLine OK
     * @throws ApiError
     */
    public static listActiveListBusinessLines(
version: string,
): CancelablePromise<Array<CrmBusinessLine>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/user/v{version}/Project/ListActiveBusinessLines',
            path: {
                'version': version,
            },
        });
    }

    /**
     * @param projectId 
     * @param version 
     * @returns string OK
     * @throws ApiError
     */
    public static getObfuscatedResults(
projectId: number,
version: string,
): CancelablePromise<Array<string>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/user/v{version}/Project/Obfuscated/{projectId}',
            path: {
                'projectId': projectId,
                'version': version,
            },
        });
    }

    /**
     * @param visitedProjectExpirationInMonths 
     * @param version 
     * @returns number OK
     * @throws ApiError
     */
    public static getNewProjectDiffForVisitedProjectExpiration(
visitedProjectExpirationInMonths: AccountSettingsExpirationInMonths,
version: string,
): CancelablePromise<number> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/user/v{version}/Project/{visitedProjectExpirationInMonths}/Diff/New',
            path: {
                'visitedProjectExpirationInMonths': visitedProjectExpirationInMonths,
                'version': version,
            },
        });
    }

    /**
     * @param version 
     * @returns CrmBusinessLine OK
     * @throws ApiError
     */
    public static listBusinessLines(
version: string,
): CancelablePromise<Array<CrmBusinessLine>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/user/v{version}/Project/Requirement/BusinessLines',
            path: {
                'version': version,
            },
        });
    }

}
